var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVideo = function SvgVideo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 2H6C3.79086 2 2 3.79086 2 6V58C2 60.2091 3.79086 62 6 62H58C60.2091 62 62 60.2091 62 58V6C62 3.79086 60.2091 2 58 2Z",
    stroke: "#DDE2E4",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3013 41.7599C26.9533 41.9335 26.5667 42.0152 26.1783 41.9974C25.7898 41.9797 25.4123 41.8629 25.0816 41.6583C24.7509 41.4537 24.478 41.168 24.2887 40.8283C24.0994 40.4886 24 40.1061 24 39.7173V24.2826C24 23.8937 24.0994 23.5113 24.2887 23.1716C24.478 22.8319 24.7509 22.5462 25.0816 22.3416C25.4123 22.1369 25.7898 22.0202 26.1783 22.0024C26.5667 21.9846 26.9533 22.0664 27.3013 22.2399L42.7387 29.9599C43.1178 30.1491 43.4366 30.4403 43.6595 30.8006C43.8824 31.1609 44.0004 31.5762 44.0004 31.9999C44.0004 32.4236 43.8824 32.8389 43.6595 33.1993C43.4366 33.5596 43.1178 33.8507 42.7387 34.0399L27.3013 41.7599Z",
    stroke: "#ABB5BB",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/video.9ce239db.svg";
export { ForwardRef as ReactComponent };